"use client";

import { useCallback, useEffect, useState } from "react";

import { STORAGE_KEYS, THEME_COOKIE, type Theme } from "../constants";

function getLanding(): HTMLElement | null {
  return document.querySelector<HTMLElement>(".landing");
}

function resolveTheme(): Theme {
  const fromLanding = getLanding()?.getAttribute("data-theme");
  if (fromLanding === "dark" || fromLanding === "light") return fromLanding;
  const stored = (() => {
    try {
      return window.localStorage.getItem(STORAGE_KEYS.theme);
    } catch {
      return null;
    }
  })();
  if (stored === "dark" || stored === "light") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function ThemeToggle() {
  const [label, setLabel] = useState("Переключить тему");

  useEffect(() => {
    setLabel(resolveTheme() === "dark" ? "Включить светлую тему" : "Включить тёмную тему");
  }, []);

  const onToggle = useCallback(() => {
    const next: Theme = resolveTheme() === "dark" ? "light" : "dark";
    getLanding()?.setAttribute("data-theme", next);
    try {
      window.localStorage.setItem(STORAGE_KEYS.theme, next);
    } catch {
      /* приватный режим */
    }
    document.cookie = `${THEME_COOKIE}=${next}; path=/; max-age=31536000; samesite=lax`;
    setLabel(next === "dark" ? "Включить светлую тему" : "Включить тёмную тему");
  }, []);

  return (
    <button
      type="button"
      className="theme-toggle"
      data-theme-toggle
      aria-label={label}
      title="Светлая / тёмная тема"
      onClick={onToggle}>
      <svg className="icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
        <path
          className="theme-toggle__moon"
          d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
        <path
          className="theme-toggle__sun"
          d="M12 4.5V2.5M12 21.5v-2M19.5 12h2M2.5 12h2M17.3 6.7l1.4-1.4M5.3 18.7l1.4-1.4M17.3 17.3l1.4 1.4M5.3 5.3l1.4 1.4M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
